import {TheRave} from "../TheRave";
import {TheRaveParsedGameData} from "../server/data/TheRaveParsedGameData";
import {TimelineLite} from "gsap";
import {ISpecialSymbolData} from "../server/data/ITheRaveData";

export class XWaysController extends PIXI.Container {

    constructor() {
        super();
    }

    public expand(withAnimation: boolean = false): TimelineLite[] {
        const animations: TimelineLite[] = [];
        const gameData: TheRaveParsedGameData = TheRave.model.parsedGameData,
            symbolSizes: number[][] = gameData.symbolSizes;
        gameData.splitDataListxWays.forEach((data, i) => {
            const symbolPosition: number[] = data.symbolPostion,
                reel: number = symbolPosition[0],
                symbol: number = symbolPosition[1];
            animations.push(TheRave.reels[reel].replaceXWaysSymbol(symbol, data.symName, symbolSizes[reel][symbol]).timeScale(withAnimation ? 1 : 2));
        });
        return animations;
    }

    public updateFullWildPosition(reelId:number): TimelineLite [] { // Remove
        const tlList: TimelineLite [] = [];

        // SYMBOLS NUM IN DATA (5) [0, 1, 3, 1, 0]

        // Tmp
        //TheRave.reels[reelId].removeXwaysSymbols([1,2]);

        return  tlList;
    }

    public expandDxWayToWild(withAnimation:boolean = false): TimelineLite [] {
        const animations: TimelineLite[] = [];

        const dataList: ISpecialSymbolData [] = [
            {
                splitNumber: 6,
                splitPostions: [[]],
                sym: 2,
                symName: "W",
                symbolPostion: [2, 0]
            }
        ]
        /*
        splitDataListxWays: Array(1)
            0:
            splitNumber: 3
            splitPositions: [Array(2)]
            sym: 4
            symName: "M4"
            symbolPosition: (2) [0, 1]
         */

        const gameData: TheRaveParsedGameData = TheRave.model.parsedGameData,
            symbolSizes: number[][] = gameData.symbolSizes;
        dataList.forEach((data, i) => {
            const symbolPosition: number[] = data.symbolPostion,
                reel: number = symbolPosition[0],
                symbol: number = symbolPosition[1];
            animations.push(TheRave.reels[reel].doubleXwayExpansion(symbol, data.symName, symbolSizes[reel][symbol]).timeScale(withAnimation ? 1 : 2));
        });
        return animations;
    }
}